import { createContext } from 'react';

type Context = {
  userInfoConfig: Record<string, any>;
  setLocalStorage: (value: any) => void;
};
export const LocalStorageContext = createContext<Context | null>(null);
